export default __webpack_public_path__ + "static/media/logo-light.533fb4d7.svg";